import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export interface GetSuppliersEstimationPayload {
  product_description: string;
}

export interface GetSuppliersEstimationResponse {
  estimation: number;
  valid_product?: boolean;
}

const getSuppliersEstimation = async (
  payload: GetSuppliersEstimationPayload
): Promise<GetSuppliersEstimationResponse> => {
  try {
    const { data } = await apiService.post<GetSuppliersEstimationResponse>(
      '/stats/suppliers/estimation/',
      payload
    );

    return data;
  } catch (error) {
    // Silent: the caller handles failure by showing a fake fallback count rather than surfacing an error to the user.
    throw handleAxiosError(error, { silent: true });
  }
};

export default getSuppliersEstimation;
